import { Chip, Css, MultiSelectField } from "@homebound/beam";
import { PotentialBidPlanDimensionKind } from "src/generated/graphqlTypes";
import { ConfigureBidGroupsStep_PotentialBidPlanDimensionResultFragment } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";

type PersonalizationGroupsFieldProps = {
  dimensionResults: ConfigureBidGroupsStep_PotentialBidPlanDimensionResultFragment[];
  selectedGroupIds: string[];
  onChange: (groupIds: string[]) => void;
  label?: string;
  excludeGroupIds?: string[];
  readOnly?: boolean;
};

/** Shared multi-select of the available personalization GOGs, used across the bid group dimension modals. */
export function PersonalizationGroupsField(props: PersonalizationGroupsFieldProps) {
  const {
    dimensionResults,
    selectedGroupIds,
    onChange,
    label = "Personalization",
    excludeGroupIds = [],
    readOnly = false,
  } = props;

  // Group-based (personalization) results carry a `group` instead of a `type`.
  const groups = dimensionResults
    .filter((r) => r.kind === PotentialBidPlanDimensionKind.Personalization)
    .map((r) => r.group!)
    .filter((group) => !excludeGroupIds.includes(group.id));

  if (groups.isEmpty) return null;

  return (
    <MultiSelectField
      fullWidth
      readOnly={readOnly}
      label={label}
      options={groups}
      values={selectedGroupIds}
      onSelect={onChange}
      getOptionMenuLabel={getOptionMenuLabel}
    />
  );
}

/** Show the plan name to tell apart options with the same name from different plans (e.g. ADU vs main house). */
function getOptionMenuLabel(group: ConfigureBidGroupsStep_PotentialBidPlanDimensionResultFragment["group"]) {
  if (!group?.readyPlan) return group?.name;
  return (
    <div css={Css.df.aifs.gap1.w100.$}>
      <span css={Css.w("70%").$}>{group.name}</span>
      <span css={Css.w("30%").$}>
        <Chip text={group.readyPlan.name} compact title={group.readyPlan.name} />
      </span>
    </div>
  );
}
